import React from 'react';

import { Button } from '@lightspeed/flame/Button';

import { createReactRenderer } from 'helpers/react-renderer';
import CustomerAccountService from 'root/apps/QuoteMachineIntegration/services/CustomerAccountService';
import { CreateCreditAccountButtonProps } from 'root/apps/QuoteMachineIntegration/state/CreateCreditAccountButtonProps';
import { datadogRum } from 'root/datadog/datadogRum';

import EditCreditLimitModal from './EditCreditLimitModal';

const CreateCreditAccountButton = ({
  customerID,
  employeeHasPermissionsToEditCreditLimit,
}: CreateCreditAccountButtonProps) => {
  const [isEditCreditLimitModalOpen, setIsEditCreditLimitModalOpen] = React.useState(false);

  const handleCreateCreditAccount = async (amount: string) => {
    if (!employeeHasPermissionsToEditCreditLimit) {
      const data = await CustomerAccountService.createOrUpdateCustomerCreditAccount(
        customerID,
        amount
      );
      if (data) {
        window.location.reload();
      }
    } else {
      setIsEditCreditLimitModalOpen(true);
    }
  };
  const handleCreateOrEditCreditAccountLimit = async (amount: string) => {
    if (employeeHasPermissionsToEditCreditLimit) {
      try {
        const data = await CustomerAccountService.getLsCustomerAccount(customerID);

        if (data?.Customer?.creditAccountID === '0' || !data?.Customer?.creditAccountID) {
          // customer does not yet have a credit account
          const data = await CustomerAccountService.createOrUpdateCustomerCreditAccount(
            customerID,
            amount
          );
          if (data) {
            window.location.reload();
          }
        } else {
          // edit limit on existing credit account
          const res = await CustomerAccountService.createOrUpdateCustomerCreditAccount(
            customerID,
            amount
          );
          if (res) {
            window.location.reload();
          }
        }
      } catch (err) {
        datadogRum.addError(err, {
          customerID,
          accountID: window.merchantos.session.getSystemCustomerID(),
          message: 'Failed to edit credit limit',
        });
      }
    }
  };

  return (
    <>
      <Button onClick={() => handleCreateCreditAccount('0')} data-test="create-account-now-button">
        Create Account Now
      </Button>
      <EditCreditLimitModal
        onSubmit={handleCreateOrEditCreditAccountLimit}
        open={isEditCreditLimitModalOpen}
        setOpen={setIsEditCreditLimitModalOpen}
      />
    </>
  );
};

const RenderedComponent = createReactRenderer({
  component: CreateCreditAccountButton,
  selector: '[data-react-root="CreateCreditAccountButton"]',
});
export default CreateCreditAccountButton;

history.onChangeState(
  [
    {
      name: ['customer.views.customer'],
      form_name: 'view',
      tab: 'account',
      id: undefined,
    },
  ],
  () => {
    RenderedComponent.mount();
  },
  () => {
    RenderedComponent.unmount();
  }
);
